<app-header></app-header>
<main class="layout-content">
    <router-outlet />
</main>
<app-footer *ngIf="currentUrl !== '/profile' && currentUrl !== '/details' && !currentUrl.startsWith('/verify-email') && !currentUrl.startsWith('/callback')"></app-footer>
<app-loader></app-loader>
<app-toast-alerts></app-toast-alerts>
